import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Main } from '../../components'
import SupportSidebar from './SupportSidebar'
import SupportSidebarSkeleton from './SupportSidebarSkeleton'
import SupportPageHeader from './SupportPageHeader'
import type { SupportSectionSlug } from './sections'
import { supportSectionIcon } from './sections'

const SupportLayout = ({
  section,
  articles,
  articlesPending,
  title,
  titlePending,
  description,
  children,
}: PropsWithChildren<{
  section: SupportSectionSlug
  articles: wowaudit.SupportArticle[]
  articlesPending?: boolean
  title: string
  titlePending?: boolean
  description?: string
}>) => {
  const { t } = useTranslation()
  const Icon = supportSectionIcon(section)

  return (
    <Main title={title} description={description}>
      <SupportPageHeader
        title={title}
        titlePending={titlePending}
        icon={Icon}
        backTo='/support'
        backLabel={t('support.back-to-hub')}
      />

      <div className='flex flex-col lg:flex-row gap-8 lg:gap-12'>
        {articlesPending ? (
          <SupportSidebarSkeleton />
        ) : (
          <SupportSidebar section={section} articles={articles} />
        )}
        <div className='min-w-0 flex-1'>{children}</div>
      </div>
    </Main>
  )
}

export default SupportLayout
